module.exports = __webpack_public_path__ + "static/media/polpo-min.b8b828d6.svg";